import SideTool from "@/global/components/side-tool";
import './index.less';
import { Button, Modal, Table, Tooltip } from "antd";
import classnames from "classnames";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import TnMessage from "@/global/components/message";
import { ReactComponent as PlaceSvg } from '@/global/icons/table/place.svg';
import { ReactComponent as CheckSvg } from '@/global/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/global/icons/table/checked.svg';
import TnModal from "@/global/components/base-modal";
import { DataBox } from "@/global/interface/device/data-box";
import AddDataBoxModal from "./add-modal";
import EditDataBoxModal from "./edit-modal";
import { createDataBox, createDataBoxes, deleteDataBox, deleteDataBoxByPrimitiveUuid, deleteDataBoxes, getDataBoxes, updateDataBox } from "@/api/device/data-box";
import { graphicStore } from "@/global/store/graphic-store";
import { DEVICEBASE_SINGAL } from "@/passets/devicebase-engine/enums/devicebase-singal";
import { Vector3 } from "three";
import { BlockT, BoxT, CircleT, ModelBase, Point } from "pytha";
import { DEVICE_SUB_CONTROL } from "@/passets/devicebase-engine/enums/device-sub-controls";
import { DeviceComponentT } from "@/passets/devicebase-engine/models/DeviceComponentT";
import { createPrimitiveMulti, deletePrimitivesInGraphic } from "@/api/geometry/primitive";
import { SerialT } from "@/passets/devicebase-engine/models/SerialT";
import { SideContext } from "@/App";
import { SideStatus } from "@/global/store/side-store";
import { SerialTComponentJsonObject } from "@/passets/devicebase-engine/components/serial";
import { DATA_BOX_COMPONENT_TYPE, DATA_BOX_TYPE } from "@/enums/data-box-type";
import { DvrT } from "@/passets/devicebase-engine/models/DvrT";
import { DvrTComponentJsonObject } from "@/passets/devicebase-engine/components/dvr";
import LinkGlobalDataBoxModal from "./link-modal";
import { createProjectGDataBoxes, deleteProjectGDataBox, getProjectDataBoxes } from "@/api/project-device/project-data-box";
import { RsProjectGlobalDataBox } from "@/global/interface/project-device/project-data-box";
import { GlobalDataBox } from "@/global/interface/lib-device/global-data-box";
import axios from "axios";
import { getSpecialPrimitiveLayerUuid } from "@/global/utils/layer-utils";
import { LayerType } from "@/enums/layer-type";
import { findComponentByType } from "@/api/archi/conponent";
import { Component } from "@/global/interface/archi/component";
import { IpcT } from "@/passets/devicebase-engine/models/IpcT";

interface IProps {
    dataBoxType: number
}

export default function DataBoxPanel(props: IProps) {
    const { projectId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const sideContext = useContext<SideStatus>(SideContext);
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [activeRow, setActiveRow] = useState<GlobalDataBox>(null); // 表格选中行
    const [hoverRow, setHoverRow] = useState<GlobalDataBox>(null); // 鼠标悬浮行
    const [dataBoxes, setDataBoxes] = useState<GlobalDataBox[]>([]); // 采集箱列表
    const [showAddModal, setShowAddModal] = useState<boolean>(false); // 打开添加弹窗
    const [addLoading, setAddLoading] = useState<boolean>(false); // 添加弹窗的loading
    // const [showEditModal, setShowEditModal] = useState<boolean>(false); // 打开编辑弹窗
    // const [editLoading, setEditLoading] = useState<boolean>(false); // 编辑弹窗的loading
    const [muitiple, setMuitiple] = useState<boolean>(false); // 是否开启多选
    const [selectedRows, setSelectedRows] = useState<GlobalDataBox[]>([]); // 多选选中的列
    const [placeRow, setPlaceRow] = useState<GlobalDataBox>(); // 正在布置的采集箱
    // const dataBoxesRef = useRef(null); // 采集箱列表ref

    // useEffect(() => {
    //     dataBoxesRef.current = dataBoxes;
    // }, [dataBoxes])

    // 监听二级控制器结束和按下ESC
    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        // graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).add(onAssembleDeviceFinish);
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onOpeCommandControlEnd.add(onOpeCommandControlEnd);
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onProcessEscape.add(onOpeCommandControlEnd);

        return () => {
            if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
            // graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).remove(onAssembleDeviceFinish);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onOpeCommandControlEnd.remove(onOpeCommandControlEnd);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onProcessEscape.remove(onOpeCommandControlEnd);
        }
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    // 初始化
    useEffect(() => {
        if (!projectId) return;
        generateData();
    }, [+projectId, sideContext.needRenderDataBoxSide])

    // 获取采集箱列表
    const generateData = () => {
        setLoading(true);
        getProjectDataBoxes(+projectId, props.dataBoxType).then(res => {
            let data: GlobalDataBox[] = res.data || [];
            data = data?.filter(item => item.type === props.dataBoxType) || [];
            setDataBoxes(data);
        }).catch(err => {
            TnMessage.error("查询失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    // 二级控制器执行完成的回调
    const onOpeCommandControlEnd = () => {
        setPlaceRow(null);
    }


    // 监听多选的变化
    useEffect(() => {
        if (!muitiple) {
            setSelectedRows([]);
        }
    }, [muitiple])

    // 点击工具栏添加按钮
    const onAddClick = () => {
        setShowAddModal(true);
    }

    // 点击工具栏删除按钮
    const onDeleteClick = () => {
        if ((muitiple && selectedRows?.length === 0) || (!muitiple && !activeRow)) {
            TnMessage.warning("未选中采集箱");
            return;
        }
        TnModal().deleteModal({
            onOk() {
                if (!muitiple) {
                    deleteProjectGDataBox(+projectId, activeRow?.id).then(res => {
                        if (res.status === 200) {
                            let idx = dataBoxes?.findIndex(item => item.id === activeRow.id);
                            dataBoxes.splice(idx, 1);
                            setDataBoxes([...dataBoxes]);
                            setActiveRow(null);
                            TnMessage.success("删除成功");
                        }
                    }).catch(err => {
                        TnMessage.error("删除失败");
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                } else {
                    let promiseList = [];
                    for (let item of selectedRows) {
                        promiseList.push(() => deleteProjectGDataBox(+projectId, item.id));
                    }
                    axios.all(promiseList?.map(fn => fn())).then(res => {
                        let newDataBoxs = dataBoxes?.filter(item => !selectedRows?.some(r => r.id === item.id));
                        setDataBoxes(newDataBoxs);
                        setSelectedRows([]);
                        TnMessage.success("删除成功");
                    }).catch(err => {
                        TnMessage.error("删除失败");
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                }
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true
        })

    }

    // 添加采集箱点击确认
    const onAddFinish = (values: number[]) => {
        if (values?.length === 0) {
            setShowAddModal(false);
            return;
        }
        let pars: RsProjectGlobalDataBox[] = values?.map(item => {
            let par: RsProjectGlobalDataBox = {
                projectId: +projectId,
                globalDataBoxId: item,
            }
            return par;
        })
        setAddLoading(true);
        createProjectGDataBoxes(pars).then(res => {
            if (res.status === 200) {
                let newPDataBoxes = res.data || [];
                setDataBoxes([...dataBoxes, ...newPDataBoxes]);
                TnMessage.success("添加成功");
                setShowAddModal(false);
            }
        }).catch(err => {
            TnMessage.error(err?.data || "添加失败");
        }).finally(() => {
            setAddLoading(false);
        })
    }

    // 点击布置按钮
    const onPlaceClick = (row: GlobalDataBox) => {
        if (!row) return;
        if (!location.pathname.match(/^\/bim\/project\/\d+\/draw\/draw-main\/?$/)) {
            navigate(`/bim/project/${projectId}/draw/draw-main`);
            TnMessage.info("正在切换至绘图区...", { duration: 1 });
            return;
        }
        setPlaceRow(row);
        let layerType;
        if (props.dataBoxType === DATA_BOX_TYPE.DVR) {
            layerType = LayerType.DVR;
        } else if (props.dataBoxType === DATA_BOX_TYPE.SERIAL) {
            layerType = LayerType.SERIAL;
        } else if (props.dataBoxType == DATA_BOX_TYPE.IPC) {
            layerType = LayerType.IPC
        }

        findComponentByType(DATA_BOX_COMPONENT_TYPE[props.dataBoxType]).then(res => {
            let data: Component = res.data;
            let block;
            if (props.dataBoxType === DATA_BOX_TYPE.SERIAL) {
                let component = new SerialT().fromJson(data);
                block = new SerialT(new Point(component?.position?.x, component?.position?.y, component?.position?.z), [component]);
            } else if (props.dataBoxType === DATA_BOX_TYPE.DVR) {
                let component = new DvrT().fromJson(data);
                block = new DvrT(new Point(component?.position?.x, component?.position?.y, component?.position?.z), [component]);
            } else if (props.dataBoxType == DATA_BOX_TYPE.IPC) {
                let component = new IpcT().fromJson(data);
                block = new IpcT(new Point(component?.position?.x, component?.position?.y, component?.position?.z), [component]);
            }
            block.isColorByLayer = false;
            block.extraData = {
                globalDataBoxId: row?.id,
            }

            getSpecialPrimitiveLayerUuid(projectId, layerType).then((layerUuid: string) => {
                graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(DEVICE_SUB_CONTROL.ASSEMBLEDEVICE.name);
                block.layerUuid = layerUuid;
                graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDevice)
                    .dispatch(block, new Vector3(block?.position?.x, block?.position?.y, block?.position?.z), layerUuid);
                TnMessage.info("开始布置设备...")
            });
        })
    }

    return (
        <div className="databox-container">
            <SideTool onAddClick={onAddClick}
                // onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                onSelectClick={() => setMuitiple(true)}
                onUnSelectClick={() => setMuitiple(false)}
            />
            <div className="table-area">
                <Table
                    rowKey="id"
                    pagination={false}
                    dataSource={dataBoxes}
                    className='tn-monix-table'
                    rowClassName={row => classnames({
                        "monix-row-select": activeRow?.id === row.id
                    })}
                    bordered={false}
                    onRow={row => {
                        return {
                            onClick: () => setActiveRow(row),
                            onMouseEnter: () => setHoverRow(row),
                            onMouseLeave: () => setHoverRow(null),
                        }
                    }}
                    sticky
                    loading={loading}
                >
                    <Table.Column dataIndex="name" title="名称" width='33%' ellipsis
                        render={(value, row: GlobalDataBox) => {
                            return (
                                <>
                                    <Tooltip title={value} placement="bottom">
                                        <div className='multi-cell'>
                                            <div className="multi-icon" onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                let idx = selectedRows?.findIndex(item => item.id === row.id);
                                                if (idx === -1) {
                                                    setSelectedRows([...selectedRows, row]);
                                                } else {
                                                    selectedRows.splice(idx, 1);
                                                    setSelectedRows([...selectedRows]);
                                                }
                                            }}>
                                                {muitiple && !selectedRows?.some(item => item?.id === row?.id) && <CheckSvg />}
                                                {muitiple && selectedRows?.some(item => item?.id === row?.id) && <CheckedSvg />}
                                            </div>
                                            <div className="multi-text">{value}</div>
                                        </div>
                                    </Tooltip>
                                </>
                            )
                        }}
                    />
                    <Table.Column dataIndex="marking" title="型号" width='34%' ellipsis align="center"
                        render={(value) => {
                            return (
                                <Tooltip title={value} placement="bottom">
                                    <div className='cell'>{value}</div>
                                </Tooltip>
                            )
                        }}
                    />
                    <Table.Column dataIndex="channelCount" title="通道数" width='33%' ellipsis align="right"
                        render={(value, row: GlobalDataBox) => {
                            if (!!hoverRow && hoverRow?.id === row?.id && !placeRow) {
                                return (
                                    <div className="place-button" onClick={() => onPlaceClick(row)}>
                                        <div className="place-icon"><PlaceSvg /></div>
                                        <div className="place-text">布置</div>
                                    </div>
                                )
                            } else {
                                return (
                                    <Tooltip title={value} placement="bottom">
                                        <div className='cell'>{value}</div>
                                    </Tooltip>
                                )
                            }

                        }}
                    />
                </Table>
            </div>

            {showAddModal && <LinkGlobalDataBoxModal dataBoxType={props.dataBoxType} visible={showAddModal} setVisible={setShowAddModal}
                onFinish={onAddFinish} loading={addLoading} filterItems={dataBoxes} />}
            {/* {showAddModal && <AddDataBoxModal dataBoxType={props.dataBoxType} visible={showAddModal} setVisible={setShowAddModal} onFinish={onAddFinish} loading={addLoading} />} */}
            {/* {showEditModal && <EditDataBoxModal dataBox={activeRow} visible={showEditModal} setVisible={setShowEditModal} onFinish={onEditFinish} loading={editLoading} />} */}
        </div>
    )
}